import React, { Component } from 'react';
import FilterBasic from '../../../basicElement/FilterBasic';
import API_URL from '../../../../common/url';

class Filter extends Component {
    render() {
        const { ...rest } = this.props;
        const filters = [{
            name: '客户名称',
            key: 'customerCompany',
            type: 'searchMulRetrieve',
            typeProperty: {
                keyword: 'customerCompanyName',
                style: {width: 160},
                placeholder: '输入客户名称检索',
                params: {limit: 20},
                url: API_URL.investigation.queryCustomerCompanyByName,
                config: { id: 'customerCompanyId', name: 'customerCompanyName' }
            }
        }, {
            name: 'JDE主项目号',
            key: 'jdeMainCode',
            type: 'input',
        }, { 
            name: '项目简称',
            key: 'investigation',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'investigationName',
                style: {width: 160},
                placeholder: '输入名称检索',
                params: {limit: 20},
                url: API_URL.investigation.queryInvestigationByName,
                config: { id: 'investigationId', name: 'investigationName' }
            }
        }, {
            name: '客户代码',
            key: 'customerCompanyCode',
            type: 'input',
        }, {
            name: '客户标签',
            key: 'customerTag',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'tagValue',
                style: {width: 140},
                placeholder: '输入客户标签检索',
                params: {limit: 20},
                url: API_URL.contract.queryCustomerTagList,
                config: { id: 'customerTagId', name: 'tagValue' }
            }
        }, {
            name: 'CSA',
            key: 'user',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyWord',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: { limit: 20, roleCodes: 'CSA,CSAL' },
                url: API_URL.execute.queryEmpListByRoleCode,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' },
            }
        },{
            name: '是否内部公司不计入',
            key: 'internalCompanyExcludeIncome',
            type: 'select',
            typeProperty: {
                
                style: {width: 100},
                placeholder: '请选择',
                list:[
                    { label: '是', value: 1 },
                    { label: '否', value: 0 },
                ]
            }
        },{
            name: '有无请款手册',
            key: 'hasEnclosureFile',
            type: 'select',
            typeProperty: {
                style: {width: 100},
                placeholder: '请选择',
                list:[
                    { label: '有', value: '1' },
                    { label: '无', value: '0' },
                ]
            }
        },{
            name: '联系人电话',
            key: 'userMobile',
            type: 'input',
            typeProperty: {
                style: {width: 100},
                placeholder: '请输入',
            }
        },{
            name: '联系人邮箱',
            key: 'userMail',
            type: 'input',
            typeProperty: {
                style: {width: 100},
                placeholder: '请输入',
            }
        },{
            name: '大客户经理',
            key: 'keyAccountManager',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyWord',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: { limit: 20, needPosition: 'TRUE' },
                url: API_URL.execute.queryEmpListByRoleCode,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' },
            }
        }];
        return (
            <FilterBasic filters={filters} {...rest} />
        );
    }
};

export default Filter;


// WEBPACK FOOTER //
// ./src/components/contractManagement/responseCustomer/Components/Filter.js